import React from 'react';

import styled from '@emotion/styled';

import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const LabelElement = styled.label({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtle'),
  display: 'inline-block',
  marginBottom: token('space.050', '4px'),
  marginTop: 0,
});

export function Label(
  props: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >,
) {
  return (
    <Box>
      {/* eslint-disable-next-line styled-components-a11y/label-has-associated-control,styled-components-a11y/label-has-for */}
      <LabelElement {...(props as any)} />
    </Box>
  );
}
